import React from 'react';

import ViewFrame from '../view-frame/ViewFrame';
import NavLink from '../nav-link/NavLink';

const Forbidden = () => (
  <ViewFrame title="Forbidden">
    <div>
      <h3>Access denied</h3>
      <NavLink to="/dashboard">
        Back
      </NavLink>
    </div>
  </ViewFrame>
);

export default Forbidden;
